module.exports = __webpack_public_path__ + "static/media/clock.e9fbd5d6.svg";